import { BAOCustomElement } from '@bao/custom-element'
import { MediaBreakpoints } from '@bao/media'
import {
  setInitialised,
  useArrows,
  usePagination,
  useScrollbar,
  addWheelControls,
} from '@bao/carousel'

const KeenSlider = window.KeenSlider

class KeenCarousel extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    let direction = 'horizontal'
    let wheelControlConfig = {}

    if (this.dataset.vertical === 'true') {
      direction = 'vertical'

      wheelControlConfig = {
        sensitivity: 1.5,
        maxDelta: 50,
      }
    }

    const breakpoints = this.getBreakpoints()

    const plugins = [
      setInitialised(),
      addWheelControls(direction, wheelControlConfig),
    ]

    if (this.config.pagination.enable) {
      plugins.push(
        usePagination(this.els?.pagination?.element, {
          format: this.config.pagination.format,
        }),
      )
    }

    if (this.config.arrows) {
      plugins.push(
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      )
    }

    if (this.config.scrollbar) {
      plugins.push(useScrollbar(this.els?.scrollbar?.element))
    }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1000,
        },
        loop: this.config.loop,
        initial: this.config.initialSlide,
        mode: 'snap',
        slides: {
          origin: this.config.centred ? 'center' : 'auto',
          perView: 'auto',
          spacing: this.config.spacing,
        },
        vertical: this.config.vertical,
        breakpoints,
      },
      [...plugins],
    )
  }

  getBreakpoints () {
    const breakpoints = {}

    if (this.config.disableDesktop) {
      breakpoints[`(min-width: ${MediaBreakpoints.breakpoints.md}px)`] = {
        disabled: true,
      }
    }

    if (this.config.desktopCentred !== null) {
      breakpoints[`(min-width: ${MediaBreakpoints.breakpoints.md}px)`] = {
        ...breakpoints[`(min-width: ${MediaBreakpoints.breakpoints.md}px)`],
        slides: {
          origin: this.config.desktopCentred ? 'center' : 'auto',
          perView: 'auto',
          spacing: this.config.spacing,
        },
      }
    }

    return breakpoints
  }

  get config () {
    return {
      arrows: this.dataset.arrows === 'true',
      centred: this.dataset.centerSlides === 'true',
      desktopCentred:
        this.dataset.desktopCenterSlides === undefined
          ? null
          : this.dataset.desktopCenterSlides === 'true',
      disableDesktop: this.dataset.disableDesktop === 'true',
      initialSlide: Number(this.dataset.initialSlide) || 0,
      loop: this.dataset.loop === 'true',
      pagination: {
        enable: this.dataset.pagination === 'true',
        format: this.dataset.paginationFormat || '',
      },
      scrollbar: this.dataset.scrollbar === 'true',
      spacing: this.dataset.spacing || 2,
      vertical: this.dataset.vertical === 'true',
    }
  }
}

if (!customElements.get('keen-carousel')) {
  customElements.define('keen-carousel', KeenCarousel)
}
